import { DrivingSchool } from "./driving-school"

export class DrivingSchoolList {
  constructor(list = {}) {
    this.total_count = list.total_count || 0;
    this.total_paid = list.total_paid || 0;
    this.items = list.results ? list.results.map(item => new DrivingSchool(item)) : [];
  }
}